import FormModal from '../../../components/Modals/FormModal';
import type { ProductionBatch } from '../../../types/restaurant/RestaurantProductionPlannerTypes';
import { formatDecimal, formatMoney } from '../../../utils/decimalValue';

const sourceLabel = {
  INVENTORY: 'Inventario',
  PURCHASE: 'Compra',
  INVENTORY_AND_PURCHASE: 'Inventario + compra',
} as const;

const ProductionBatchDetailModal = ({
  batch,
  isOpen,
  onClose,
}: {
  batch: ProductionBatch | null;
  isOpen: boolean;
  onClose: () => void;
}) => (
  <FormModal
    isOpen={isOpen}
    onClose={onClose}
    title="Detalle del lote de producción"
    maxWidth="max-w-4xl"
  >
    {batch && (
      <div className="space-y-5">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          <div className="rounded-lg bg-gray-2 p-3 dark:bg-meta-4">
            <p className="text-xs text-bodydark2">Lote</p>
            <p className="font-semibold">#{batch.id}</p>
          </div>
          <div className="rounded-lg bg-gray-2 p-3 dark:bg-meta-4">
            <p className="text-xs text-bodydark2">Fuente</p>
            <p className="font-semibold">{sourceLabel[batch.source]}</p>
          </div>
          <div className="rounded-lg bg-gray-2 p-3 dark:bg-meta-4">
            <p className="text-xs text-bodydark2">Fecha</p>
            <p className="font-semibold">
              {new Date(batch.createdAt).toLocaleString('es-SV')}
            </p>
          </div>
          <div className="rounded-lg bg-success/10 p-3 text-success">
            <p className="text-xs">Costo total</p>
            <p className="font-bold">{formatMoney(batch.totalCost)}</p>
          </div>
        </div>
        <div className="overflow-x-auto rounded-lg border border-stroke dark:border-strokedark">
          <table className="w-full min-w-[650px] text-left text-sm">
            <thead className="bg-gray-2 text-xs uppercase text-bodydark2 dark:bg-meta-4">
              <tr>
                <th className="p-3">Producto</th>
                <th className="p-3">Receta</th>
                <th className="p-3">Cantidad</th>
                <th className="p-3">Costo unitario</th>
                <th className="p-3 text-right">Total</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stroke dark:divide-strokedark">
              {batch.items.map((item) => (
                <tr key={item.id}>
                  <td className="p-3 font-medium text-black dark:text-white">
                    {item.productName}
                  </td>
                  <td className="p-3">{item.recipeName}</td>
                  <td className="p-3">{formatDecimal(item.quantity)}</td>
                  <td className="p-3">{formatMoney(item.unitCost)}</td>
                  <td className="p-3 text-right font-semibold">
                    {formatMoney(item.totalCost)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {batch.purchaseNumber && (
          <p className="text-sm">
            <strong>Compra asociada:</strong> {batch.purchaseNumber}
          </p>
        )}
        {batch.notes && (
          <div className="rounded-lg border border-stroke p-4 text-sm dark:border-strokedark">
            <strong>Notas:</strong>
            <p className="mt-1 whitespace-pre-wrap">{batch.notes}</p>
          </div>
        )}
      </div>
    )}
  </FormModal>
);

export default ProductionBatchDetailModal;
